import React, { useEffect } from "react";

import { HeaderCustomer } from "@payright/web-components";
import { useDispatch, useSelector } from "react-redux";

import { loadPageData } from "../../actions";
import LoanStatementForm from "./LoanStatementForm";
import Loader from "../Common/Loader";
import Footer from "../Footer";
import { Nav } from "../Nav";
import { RootState } from "../../reducers";
const title = "Your Statement";

const LoanStatements = ({}) => {
  const dispatch = useDispatch();

  const { customer } = useSelector<RootState, {customer: any}>(state => ({
    customer: state.pageData.customer,
  }));

  useEffect(() => {
    if (customer === null) {
      dispatch(loadPageData());
    }
  }, [customer])

  if (!customer) {
    <Loader text="Fetching customer details..." />
  }

  return (
    <div>
      <div className="customer-navigation">
      <Nav activePage="/loan-statements" />
        <HeaderCustomer title={title} />
        <LoanStatementForm />
      </div>
      <Footer />
    </div>
      
  )
}

export default LoanStatements;
